// The focused pane's text size for a moment after ⌘+ / ⌘− / ⌘0 ("110%"), so it's plain which pane changed: in the
// pane's corner, fading out after 800ms (a fade only, so nothing moves with Reduce Motion either).

import { useEffect, useState } from 'react';
import { onZoom } from '../term/zoom';

export function ZoomReadout({ sid }: { sid: number }) {
  const [percent, setPercent] = useState<number | null>(null);
  // each zoom restarts the 800ms, even at the same size
  const [shown, setShown] = useState(0);
  useEffect(
    () =>
      onZoom((id, p) => {
        if (id !== sid) return;
        setPercent(p);
        setShown((n) => n + 1);
      }),
    [sid],
  );
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!shown) return;
    setOn(true);
    const t = setTimeout(() => setOn(false), 800);
    return () => clearTimeout(t);
  }, [shown]);
  return (
    <div className="ws-zoom" data-on={on ? '' : undefined} role="status" aria-live="polite" data-testid="zoom-readout">
      {percent !== null && `${percent}%`}
    </div>
  );
}
